export default __webpack_public_path__ + "static/media/crown-chakra.373bee87.png";